export const SET_LOADING = 'SET_LOADING';
export const SET_INVOICES = 'SET_INVOICES';
export const SET_INVOICE = 'SET_INVOICE';
export const SET_INVOICES_TO_CREATE = 'SET_INVOICES_TO_CREATE';
export const UPDATE_INVOICE_TO_CREATE = 'UPDATE_INVOICE_TO_CREATE';
export const SET_BASE_TRANSPORT_COURSES = 'SET_BASE_TRANSPORT_COURSES';
export const SET_TRANSPORT_COURSES = 'SET_TRANSPORT_COURSES';
